import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import reducer from './app/state/rootReducer';
import createStore from './app/state/createStore';
import http from './app/request/httpProvider';
import auth from './app/request/authenticationProvider';
import './index.css';
import { StyleSheetManager } from 'styled-components';
import { IDSThemeProvider } from 'spark-ui/ids-react-compat';
import App from './app/views/main/App';
import registerServiceWorker from './registerServiceWorker';

/**
 * React-router has two ways to create history.
 * Either you can directly render a specific Router component (i.e, BrowserRouter),
 * or you can use the createHistory api.
 *
 * Here, we use the createHistory api so that we can interact with the history through
 * Redux. This has the added benefit of making mocking the history api easier for unit
 * testing.
 */
const history = createBrowserHistory({
    basename: process.env.REACT_APP_ROUTER_BASE || ''
});

const store = createStore(reducer, auth, http, history);

const appTree = (
    <IDSThemeProvider themeName="IDS">
        <Provider store={store}>
            <App history={history} />
        </Provider>
    </IDSThemeProvider>
);

/**
 * Mount styled-components into a fixed <style> in index.html so rules from material-ui
 * JSS (`withStyles`) are typically appended *after* it in <head>. At equal specificity,
 * JSS then wins (restores pre-upgrade cascade vs styled-components v5). See changelog §8.1.
 * Jest / environments without the insertion point keep default SC behaviour.
 */
const styledComponentsTarget =
    typeof document !== 'undefined' ? document.getElementById('styled-components-insertion-point') : null;

const AppContainer = styledComponentsTarget ? (
    <StyleSheetManager target={styledComponentsTarget}>{appTree}</StyleSheetManager>
) : (
    appTree
);

/**
 * Renders the React app to the real DOM.
 * <div id="root" /> exists in spark/public/index.html
 */
ReactDOM.render(AppContainer, document.getElementById('root'));

registerServiceWorker();
